/* eslint-disable camelcase */
import React from 'react';
import { dateFormat } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var issuedCreditsReferenceColumns = [{
  name: 'Дата на отпускане',
  value: 'issued_date',
  dateTimeFormat: dateFormat
}, {
  name: '№ договор',
  value: 'number',
  width: '110px'
}, {
  name: 'Период',
  render: function render(_ref) {
    var period_months = _ref.period_months;
    return ___EmotionJSX("span", {
      "data-value": "period_months"
    }, period_months, " \u043C\u0435\u0441.");
  }
}, {
  name: 'Главница',
  render: function render(_ref2) {
    var principal = _ref2.principal,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, principal, " ", currency);
  }
}, {
  name: 'Лихва',
  render: function render(_ref3) {
    var total_interest = _ref3.total_interest,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interest"
    }, total_interest, " ", currency);
  }
}, {
  name: 'Такса посещение',
  render: function render(_ref4) {
    var home_visit_fee = _ref4.home_visit_fee,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "home_visit_fee"
    }, home_visit_fee, " ", currency);
  }
}];